import { RequestHandlerInterface } from '~/models/interfaces/infraestructure/api'

const initialState: RequestHandlerInterface = {
  amountRequest: 0,
}

export default initialState
